var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "f9tabs" }, [
    _c("div", { staticClass: "tabs" }, [
      _c(
        "ul",
        _vm._l(_vm.tabs, function(tab, index) {
          return _c(
            "li",
            { key: index, class: { "is-active": tab.isActive } },
            [
              _c(
                "a",
                {
                  attrs: {
                    href: tab.href,
                    "aria-role": "tab",
                    "aria-label": tab.name + " tab"
                  },
                  on: {
                    click: function($event) {
                      _vm.selectTab(tab)
                    }
                  }
                },
                [_vm._v(_vm._s(tab.name))]
              )
            ]
          )
        })
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "tabs-details",
        style: {
          height: _vm.currentTabHeight,
          overflow: _vm.currentTabOverflow
        }
      },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-187fb35c", { render: render, staticRenderFns: staticRenderFns })
  }
}